import { render, staticRenderFns } from "./color-picker.html?vue&type=template&id=6b753797&scoped=true&"
import script from "./color-picker.js?vue&type=script&lang=js&"
export * from "./color-picker.js?vue&type=script&lang=js&"
import style0 from "./color-picker.scss?vue&type=style&index=0&id=6b753797&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b753797",
  null
  
)

export default component.exports